var map = {
	"./column.js": 222,
	"./course.js": 207,
	"./doctor.js": 259,
	"./home.js": 212,
	"./iconList.js": 260,
	"./index.js": 85,
	"./knowledge.js": 213,
	"./message.js": 208,
	"./mini-cord.js": 261,
	"./recommend.js": 262,
	"./resource.js": 205,
	"./statistics.js": 263,
	"./tags.js": 209,
	"./template.js": 264,
	"./user.js": 265,
	"./video.js": 266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;